import {
  Card,
  CardContent,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";

import { FinancialStatementTotalsRow } from "../domain/entities/financial";

import MonetaryText from "./MonetaryText";

// Legacy
import ScrollToTop from "../../../components/nav/ScrollToTop";

interface SummaryTotalsProps {
  title: string;
  stepTotals: FinancialStatementTotalsRow[];
  disposableIncome?: number;
}

const SummaryTotals = ({
  title,
  stepTotals,
  disposableIncome,
}: Readonly<SummaryTotalsProps>) => {
  return (
    <>
      <ScrollToTop />
      <Card sx={{ mb: 2, borderRadius: "0px" }}>
        <CardContent>
          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>
          <TableContainer>
            <Table aria-label="totals summary table">
              <TableBody>
                {stepTotals.map((item) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell sx={{ fontSize: 16, fontWeight: "bold" }}>
                        {item.name}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: 16,
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        <MonetaryText value={item.value} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {disposableIncome && (
                  <TableRow>
                    <TableCell
                      sx={{
                        fontSize: 20,
                        fontWeight: "bold",
                        color: "primary.dark",
                      }}
                    >
                      My Disposable Income
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: 20,
                        fontWeight: "bold",
                        textAlign: "right",
                        color:
                          disposableIncome && disposableIncome > 0
                            ? "green"
                            : "purple",
                      }}
                    >
                      <MonetaryText value={disposableIncome ?? 0} />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </>
  );
};

export default SummaryTotals;
